import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { db } from "../db/firestore";
import { endCutoff,  manageBill, startCutoff } from '../Utility/function';
import { NumberYMD, minusDays, stringYMDHMS3 } from '../Utility/dateTime';
import { initialCheckOut } from '../configs'

const initialState = {
    bills:[], // 
    normalBill:[],
    voidedBill:[],
    modal_Bill:false,
    billDates:[],
    selectedBill:[],
    selectedVoidedBill:[],
    startDate:new Date(),
    endDate:new Date(),

};

export const fetchBill = createAsyncThunk(
  'bill/fetchBill',
  async ({ shopId, billDate, cutOff, startDate, endDate, callBack=()=>{} }) => {
    const chunkSize = 3;
    // const chunkSize = 10;
    const maxConcurrentPromises = 5; // Limit concurrency to 5

    const chunkArray = (array, size) =>
      Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
        array.slice(index * size, index * size + size)
      );

    const billDateChunks = chunkArray(billDate, chunkSize);
    const totalChunks = billDateChunks.length;
    let completedChunks = 0; // Track progress

    const queue = [];
    const results = [];

      for (const [chunkIndex, chunk] of billDateChunks.entries()) {
        if (queue.length >= maxConcurrentPromises) {
          await Promise.race(queue); // Wait for one promise to resolve
        }

        const promise = (async () => {
          try {
            const query = db.collection('bill')
              .where('shopId', '==', shopId)
              .where('billDate', 'in', chunk);

            if (startDate && endDate) {
              query.where('dateTime', '>=', startDate).where('dateTime', '<=', endDate);
            }

            const qsnapshot = await query.get();
            if (!qsnapshot.empty) {
              qsnapshot.forEach((doc) => {
                const { dateTime,  ...rest } = {
                  ...initialCheckOut,
                  ...doc.data(),
                };
                results.push({
                  ...rest,
                  dateTime: dateTime.toDate(),
                  id: doc.id,
                });
              });
            }
          } catch (err) {
            console.error(`Error fetching data for shopId ${shopId}:`, err);
          } finally {
            completedChunks++; // Update progress
       
            callBack(completedChunks*100/totalChunks)
          }
        })();

        queue.push(promise);

        // Remove completed promises from the queue
        promise.finally(() => {
          const index = queue.indexOf(promise);
          if (index > -1) queue.splice(index, 1);
        });
      }

    // Wait for all promises to resolve
    await Promise.all(queue);

    console.log('All chunks processed successfully.');
    return { data: results, billDate, cutOff, startDate, endDate };
  }
);


export const billSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    updateStartDate: (state, action) => {
      state.startDate = action.payload
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload
    },
    clearBill: state => {
      state.bills =[]
      state.normalBill = []
      state.voidedBill = []
      state.billDates = []
      state.selectedBill = []
      state.selectedVoidedBill = []
      state.startDate = new Date()
      state.endDate = new Date()
    },
    updateModal_Bill: state => {
      state.modal_Bill = !state.modal_Bill
    },
    updateBills: (state, action) => {
      const { startDate, endDate, cutOff } = action.payload;
      const cutoffDate = new Date(cutOff);
      const start = startCutoff(startDate, cutoffDate);
      const end = endCutoff(endDate, cutoffDate);
    
      const isInRange = item => {
        const date = new Date(item.dateTime);
        return date > start && date <= end;
      };
    
      state.selectedBill = state.normalBill.filter(isInRange);
      state.selectedVoidedBill = state.voidedBill.filter(isInRange);
    },
    
  },
  extraReducers: builder => {
    builder.addCase(fetchBill.pending, state => {
      state.modal_Bill = true
    })
    builder.addCase(fetchBill.fulfilled, (state, action) => {
      const { data, billDate, cutOff, startDate, endDate } = action.payload;
      const now = new Date();
      const cutoffDate = new Date(cutOff);
      const isDuplicate = billDate.some(date => Number(date) >= NumberYMD(minusDays(now, 1)));
    
      if (isDuplicate) {
        const { bills, normalBills, voidedBills } = manageBill(state.bills, data);
        state.bills = bills;
        state.normalBill = normalBills;
        state.voidedBill = voidedBills;
      } else {
        state.bills.push(...data);
        state.normalBill.push(...data.filter(item => !item.void));
        state.voidedBill.push(...data.filter(item => item.void === true));
      }
    
      const filterByCutoff = item => {
        const date = new Date(item.dateTime);
        return date > startCutoff(startDate, cutoffDate) && date <= endCutoff(endDate, cutoffDate);
      };
    
      state.selectedBill = state.normalBill.filter(filterByCutoff);
      state.selectedVoidedBill = state.voidedBill.filter(filterByCutoff);
      state.billDates.push(...billDate.filter(date => date < stringYMDHMS3(now)));
      state.modal_Bill = false;
    });
    
    builder.addCase(fetchBill.rejected, state => {
        state.modal_Bill = false
    })
  }
})

export const { 
  updateModal_Bill, 
  updateBills, 
  clearBill, 
  updateStartDate, 
  updateEndDate
} = billSlice.actions

export default billSlice.reducer